import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { deleteControlGroup } from '../Api'

export default generateApiAction({
  baseType: Types.CTRL_GROUPS.DELETE,
  api: deleteControlGroup,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/controlGroups/DeleteAction.js